import { MutableRefObject } from 'react';
import PhoneInput, { CountryData } from 'react-phone-input-2';
import { Form, InputGroup } from 'react-bootstrap';
import { IPhone } from '@/domain/interfaces/IUser';


interface PhoneInputMainProps {
    phone: MutableRefObject<IPhone>;
    classWithError?: boolean;
    phoneNumberLabel: string;
    phoneErrorMessage: string;
    validateForm: () => void;
    /** Establece el estado del input */
    disabledField?: boolean;
}

/**
 *  Componente maestro de numero telefónico internacional 
 * @component
 * */
const PhoneInputMain = ({
    phone,
    classWithError = false,
    phoneNumberLabel,
    phoneErrorMessage,
    validateForm,
    disabledField = false,
}: PhoneInputMainProps): JSX.Element => {
    return (
        <InputGroup className='mb-3 text-center px-1'>
            <div className='pt-2 w-100'>
                <div className='d-flex justify-content-between'>
                    <Form.Label>
                        <span className={`text-nowrap p-regular-medium`}>{phoneNumberLabel}</span>
                    </Form.Label>
                    <div>
                        <span className={'text-complementary-2 text-nowrap'}>{phoneErrorMessage}</span>
                    </div>
                </div>
            </div>
            <PhoneInput
                country={'cl'}
                onlyCountries={['cl']}
                disabled={disabledField}
                value={phone.current?.number ?? ''}
                placeholder='Enter phone number'
                onChange={(number: string, country: CountryData) => {
                    phone.current.number = number;
                    phone.current.country = country.countryCode.toUpperCase();
                    validateForm();
                }}
                countryCodeEditable={false}
                masks={{ cl: '. .... ....' }}
                autoFormat={true}
                inputClass={` mh-40-px form-control ${classWithError ? 'form-control-error' : ''}  position-relative w-100 `}
            />
        </InputGroup>
    )
}

export default PhoneInputMain